module.exports = __webpack_public_path__ + "static/media/MoreInformationRequiered.8df7f05f.svg";